var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page24"},[_c('h2',{attrs:{"id":"title"}},[_vm._v("产品技术优势")]),_c('TwoflanksTree',{ref:"twoflanks",attrs:{"id":"twoflanks"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }